module.exports = __webpack_public_path__ + "static/media/kyc.dda32ff4.svg";